import React from "react";
import { useNavigate } from "react-router-dom";
import useBlogs from "hooks/useBlogs";

function BlogCard({ post }) {
  const navigate = useNavigate();

  return (
    <div
      className="blog-card"
      onClick={() => {
        navigate(`/${post.slug}`);
      }}
    >
      <img src={post.image} alt={post.title} />
      <div className="blog-card-overlay" />
      <span className="blog-card-date">{post.date}</span>
      <p className="blog-card-title">{post.title}</p>
    </div>
  );
}

export default function Blog() {
  const { blogs, loading, error } = useBlogs();
  console.log("api/v1/public/blogs", blogs);

  if (loading) {
    return (
      <section style={{ padding: "80px 0", textAlign: "center" }}>
        <p style={{ color: "#0a2e14", opacity: 0.6 }}>Loading posts...</p>
      </section>
    );
  }

  if (error || blogs.length === 0) return null;

  return (
    <section style={{ padding: "80px 0", textAlign: "center" }}>
      <div
        style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}
      >
        <span className="showcase-badge">LATEST POSTS</span>
      </div>

      <h2
        className="title-cool"
        style={{
          fontSize: "clamp(2rem, 4vw, 3.2rem)",
          color: "#0a2e14",
          margin: "0 32px",
        }}
      >
        The latest updates from NumbersAG
      </h2>

      <div className="blog-grid">
        {blogs.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  );
}
